import { usePostApiSupportTicketMutation } from '@/model/support/api.generated';
import { useAppSelector } from '@/shared/hooks/useStore';
import { useTrans } from '@/shared/hooks/useTranslation';
import {
  toCreateTicketRequest,
  toSupportTicketView,
} from '@/viewmodel/features/support/mappers/supportTicket';
import type { SupportTicketView } from '@/viewmodel/features/support/types';
import { selectUserData } from '@/viewmodel/features/user';
import { notify } from '@/viewmodel/shared/notify';

export function useSupportTicket(onSuccess: (ticket: SupportTicketView) => void): {
  createTicket: (formData: Record<string, string>) => Promise<void>;
  isLoading: boolean;
} {
  const { t } = useTrans();
  const [postTicket, { isLoading }] = usePostApiSupportTicketMutation();
  const userEmail = useAppSelector(selectUserData).data?.email ?? '';

  const createTicket = async (formData: Record<string, string>): Promise<void> => {
    try {
      const result = await postTicket({
        supportCreateTicketRequest: toCreateTicketRequest(formData, userEmail),
      }).unwrap();
      onSuccess(toSupportTicketView(result.data));
    } catch {
      notify(t('support.error'), 'danger');
    }
  };

  return { createTicket, isLoading };
}
